import { useCampus } from '../contexts/CampusContext';
import * as velloreConfig from './vellore';
import * as chennaiConfig from './chennai';
import * as apConfig from './ap';
import { generateTimeBasedConflicts } from '../utils/time';
import { CampusConfig } from '../types/config';

const useConfig = () => {
  const { campus } = useCampus();

  let campusConfig: Omit<CampusConfig, 'slotConflictPairs'>;

  switch (campus) {
    case 'Chennai':
      campusConfig = chennaiConfig;
      break;
    case 'AP':
      campusConfig = apConfig;
      break;
    case 'Vellore':
    default:
      campusConfig = velloreConfig;
      break;
  }

  const fullConfig: CampusConfig = {
    ...campusConfig,
    slotConflictPairs: [], // Initial empty array
  };

  fullConfig.slotConflictPairs = generateTimeBasedConflicts(fullConfig);

  return fullConfig;
};

export default useConfig; 